import React, { useState, useEffect } from 'react';
import { Play } from 'lucide-react';
import dentalTeamMember from '../../assets/dentalTeamMember.png';
import dentalProcedure from '../../assets/dentalProcedure.png';
import TypingEffect from '../Common/TypingEffect';

const AboutDetail = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="mx-auto py-16 px-4 md:px-8 lg:px-20 relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 relative">
        {/* Left Column */}
        <div className={`space-y-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
          <h2 className="text-3xl md:text-4xl font-serif text-gray-800">
            Serving patients with{' '}
            <span className="text-teal-500">
              <TypingEffect />
            </span>
          </h2>
          
          <div className="space-y-6 text-gray-600">
            <p className="text-base md:text-lg">
              We're a group of energetic, values-driven dental clinicians dedicated to caring for all people — young 
              to young at heart. With extensive experience, we've been combining exciting technology with a warm and friendly 
              team to deliver exceptional dentistry in Vadodara.
            </p>
            
            <p className="text-base md:text-lg">
              Find all the dental care you need (and then some) here in our beautiful office, designed for your 
              comfort and rejuvenation.
            </p>
          </div>

          {/* Video Section */}
          <div className="relative aspect-video bg-gray-100 rounded-xl overflow-hidden shadow-lg transform transition-transform duration-500 hover:scale-[1.02]">
            <img 
              src={dentalProcedure}
              alt="Dental procedure video thumbnail" 
              className="w-full h-full object-cover"
            />
            <button className="absolute inset-0 flex items-center justify-center bg-black/10 hover:bg-black/20 transition-colors group">
              <div className="w-16 h-16 rounded-full bg-lime-400 flex items-center justify-center group-hover:bg-lime-500 transition-colors">
                <Play className="w-8 h-8 text-gray-800 ml-1" />
              </div>
            </button>
          </div>
        </div>

        {/* Right Column - Card */}
        <div className={`relative transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
          <div className="bg-gradient-to-br from-teal-500 to-teal-600 p-6 md:p-8 rounded-2xl shadow-xl">
            <div className="aspect-video mb-6 overflow-hidden rounded-xl">
              <img 
                src={dentalTeamMember}
                alt="Dental team members" 
                className="w-full h-full object-cover transform transition-transform duration-700 hover:scale-105"
              />
            </div>
            
            <p className="text-white text-base md:text-lg">
              At Pristine Smile, you are in good hands. With every treatment, we promise to do it right, quickly, and for a 
              fair price. And we provide a lifetime warranty on all our work — because it's the right thing to do.
            </p>
            
            <div className="mt-6 flex justify-end">
              <div className="w-16 h-16 rounded-full bg-lime-400 flex items-center justify-center transform rotate-45">
                <svg width="30" height="30" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <path d="M70 30C80 40 85 25 90 35C95 45 80 60 90 70C95 75 85 85 75 80C65 75 60 85 50 80C40 75 50 60 40 50C30 40 45 30 55 25C65 20 60 20 70 30Z" fill="white" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutDetail;